import { callApi } from "../helpers/Api";
import { isTruthy } from "../utils/helpers";
import pages from "../subscriber/Pages";

export const getSocialMedia = () => {
    const functionUrl = `social_media`;
    const isBackground = true;
    const method = "GET";

    try {
        callApi({ functionUrl, method, isBackground }).then((response) => {
            const { status, result } = response || {};
            if(isTruthy(status)) {
                pages.updateValue("social_media", result);
            }
        });
    } catch (error) {
        console.error("API error: ", error);
        return false;
    }
};